// extracted by mini-css-extract-plugin
export var animationContainer = "_g9-0";
export var asteriskIcon = "_g9-8";
export var conversationLeftSection = "_g9-4";
export var conversationListItem = "_g9-3";
export var conversationMiddleSection = "_g9-5";
export var conversationRightSection = "_g9-6";
export var detailsContent = "_g9-1";
export var listContainer = "_g9-7";
export var modalContent = "_g9-2";